import { render, staticRenderFns } from "./UpdatePassword.vue?vue&type=template&id=51e72ed3&scoped=true"
import script from "./UpdatePassword.vue?vue&type=script&lang=js"
export * from "./UpdatePassword.vue?vue&type=script&lang=js"
import style0 from "./UpdatePassword.vue?vue&type=style&index=0&id=51e72ed3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e72ed3",
  null
  
)

export default component.exports